import * as React from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import {useTranslation} from 'react-i18next';
import {resetRequestError} from '../store/reduxProperties/general/actions';
import {useDispatch} from 'react-redux';

interface ErrorModalProps {
    message: string;
    showModal: boolean;
}

export const ErrorModal: React.FC<ErrorModalProps> = (props: ErrorModalProps) => {
    const { message, showModal } = props;
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const onTryAgain = () => {
        dispatch(resetRequestError())
        window.location.reload();
    }

    return (
        <Modal backdrop="static" isOpen={showModal}>
            <ModalHeader tag={"h1"}>Fel</ModalHeader>
            <ModalBody>
                <MessagePanel message={message} bsStyle="danger" />
            </ModalBody>
            <ModalFooter>
                <button type="button" className="btn btn-primary float-right" onClick={e => onTryAgain()} aria-label={t('button.ok')}>{t('button.ok')}</button>
            </ModalFooter>
        </Modal>
    )
}

interface MessagePanelProps {
    bsStyle: string;
    message: string;
}

export const MessagePanel: React.FC<MessagePanelProps> = (props: MessagePanelProps) => {
    const { bsStyle, message } = props;
    return (
        <div className={"alert alert-" + bsStyle} role="alert">
            <p className="alert-body">
                <i className="fas fa-info-circle" /> {message}
            </p>
        </div>
    )
}
